export default {
    "movingDistance": 1.5,
    "paperHeightTrim": 1,
    "showPosition": true,
    "positionLineMode": false,
    "positionUnit": true,
    "showSizeBox": true,
    "adsorbMin": 3,
    "showAdsorbLine": true,
    "adsorbLineMin": 6,
    "paperNumberContinue": true,
    "panel": {
        "supportOptions": [
            {
                "name": "panelPaperRule",
                "hidden": true
            },
            {
                "name": "panelPageRule",
                "hidden": true
            },
            {
                "name": "firstPaperFooter",
                "hidden": true
            },
            {
                "name": "evenPaperFooter",
                "hidden": true
            },
            {
                "name": "oddPaperFooter",
                "hidden": true
            },
            {
                "name": "lastPaperFooter",
                "hidden": true
            },
            {
                "name": "leftOffset",
                "hidden": false
            },
            {
                "name": "topOffset",
                "hidden": false
            },
            {
                "name": "fontFamily",
                "hidden": false
            },
            {
                "name": "orient",
                "hidden": true
            },
            {
                "name": "paperNumberDisabled",
                "hidden": true
            },
            {
                "name": "paperNumberContinue",
                "hidden": true
            },
            {
                "name": "paperNumberFormat",
                "hidden": true
            },
            {
                "name": "watermarkOptions",
                "hidden": true
            }
        ],
        "default": {}
    },
    "text": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "title",
                        "hidden": false
                    },
                    {
                        "name": "field",
                        "hidden": false
                    },
                    {
                        "name": "testData",
                        "hidden": false
                    },
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "hideTitle",
                        "hidden": true
                    },
                    {
                        "name": "fixed",
                        "hidden": true
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "dataType",
                        "hidden": false
                    },
                    {
                        "name": "fontFamily",
                        "hidden": true
                    },
                    {
                        "name": "fontSize",
                        "hidden": false
                    },
                    {
                        "name": "fontWeight",
                        "hidden": true
                    },
                    {
                        "name": "letterSpacing",
                        "hidden": true
                    },
                    {
                        "name": "color",
                        "hidden": true
                    },
                    {
                        "name": "backgroundColor",
                        "hidden": true
                    },
                    {
                        "name": "textDecoration",
                        "hidden": true
                    },
                    {
                        "name": "textAlign",
                        "hidden": false
                    },
                    {
                        "name": "textContentVerticalAlign",
                        "hidden": false
                    },
                    {
                        "name": "textContentWrap",
                        "hidden": true
                    },
                    {
                        "name": "lineHeight",
                        "hidden": true
                    },
                    {
                        "name": "transform",
                        "hidden": true
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "边框",
                "options": [
                    {
                        "name": "optionsGroup",
                        "hidden": false
                    },
                    {
                        "name": "borderLeft",
                        "hidden": false
                    },
                    {
                        "name": "borderTop",
                        "hidden": false
                    },
                    {
                        "name": "borderRight",
                        "hidden": false
                    },
                    {
                        "name": "borderBottom",
                        "hidden": false
                    },
                    {
                        "name": "borderWidth",
                        "hidden": false
                    },
                    {
                        "name": "borderColor",
                        "hidden": false
                    },
                    {
                        "name": "contentPaddingLeft",
                        "hidden": false
                    },
                    {
                        "name": "contentPaddingTop",
                        "hidden": false
                    },
                    {
                        "name": "contentPaddingRight",
                        "hidden": false
                    },
                    {
                        "name": "contentPaddingBottom",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "textType",
                        "hidden": false
                    },
                    {
                        "name": "barcodeMode",
                        "hidden": false
                    },
                    {
                        "name": "qrCodeLevel",
                        "hidden": false
                    },
                    {
                        "name": "pageBreak",
                        "hidden": true
                    },
                    {
                        "name": "showInPage",
                        "hidden": true
                    },
                    {
                        "name": "unShowInPage",
                        "hidden": true
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    },
                    {
                        "name": "upperCase",
                        "hidden": true
                    },
                    {
                        "name": "formatter",
                        "hidden": true
                    },
                    {
                        "name": "styler",
                        "hidden": true
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "title",
                "hidden": false
            },
            {
                "name": "field",
                "hidden": false
            },
            {
                "name": "testData",
                "hidden": false
            },
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "dataType",
                "hidden": false
            },
            {
                "name": "fontFamily",
                "hidden": false
            },
            {
                "name": "fontSize",
                "hidden": false
            },
            {
                "name": "fontWeight",
                "hidden": false
            },
            {
                "name": "letterSpacing",
                "hidden": false
            },
            {
                "name": "color",
                "hidden": false
            },
            {
                "name": "textDecoration",
                "hidden": false
            },
            {
                "name": "textAlign",
                "hidden": false
            },
            {
                "name": "textContentVerticalAlign",
                "hidden": false
            },
            {
                "name": "textContentWrap",
                "hidden": false
            },
            {
                "name": "lineHeight",
                "hidden": false
            },
            {
                "name": "textType",
                "hidden": false
            },
            {
                "name": "barcodeMode",
                "hidden": false
            },
            {
                "name": "qrCodeLevel",
                "hidden": false
            },
            {
                "name": "hideTitle",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "unShowInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            },
            {
                "name": "optionsGroup",
                "hidden": false
            },
            {
                "name": "borderLeft",
                "hidden": false
            },
            {
                "name": "borderTop",
                "hidden": false
            },
            {
                "name": "borderRight",
                "hidden": false
            },
            {
                "name": "borderBottom",
                "hidden": false
            },
            {
                "name": "borderWidth",
                "hidden": false
            },
            {
                "name": "borderColor",
                "hidden": false
            },
            {
                "name": "contentPaddingLeft",
                "hidden": false
            },
            {
                "name": "contentPaddingTop",
                "hidden": false
            },
            {
                "name": "contentPaddingRight",
                "hidden": false
            },
            {
                "name": "contentPaddingBottom",
                "hidden": false
            },
            {
                "name": "backgroundColor",
                "hidden": false
            },
            {
                "name": "formatter",
                "hidden": false
            },
            {
                "name": "styler",
                "hidden": false
            }
        ],
        "default": {
            "width": 120,
            "height": 9.75
        }
    },
    "image": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "field",
                        "hidden": false
                    },
                    {
                        "name": "src",
                        "hidden": false
                    },
                    {
                        "name": "fit",
                        "hidden": false
                    },
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": false
                    },
                    {
                        "name": "unShowInPage",
                        "hidden": false
                    },
                    {
                        "name": "fixed",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": false
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    },
                    {
                        "name": "formatter",
                        "hidden": false
                    },
                    {
                        "name": "styler",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "field",
                "hidden": false
            },
            {
                "name": "src",
                "hidden": false
            },
            {
                "name": "fit",
                "hidden": false
            },
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "unShowInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            },
            {
                "name": "formatter",
                "hidden": false
            },
            {
                "name": "styler",
                "hidden": false
            }
        ],
        "default": {}
    },
    "longText": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "title",
                        "hidden": false
                    },
                    {
                        "name": "field",
                        "hidden": false
                    },
                    {
                        "name": "testData",
                        "hidden": false
                    },
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "hideTitle",
                        "hidden": false
                    },
                    {
                        "name": "fixed",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "fontFamily",
                        "hidden": false
                    },
                    {
                        "name": "fontSize",
                        "hidden": false
                    },
                    {
                        "name": "fontWeight",
                        "hidden": false
                    },
                    {
                        "name": "letterSpacing",
                        "hidden": false
                    },
                    {
                        "name": "textAlign",
                        "hidden": false
                    },
                    {
                        "name": "lineHeight",
                        "hidden": false
                    },
                    {
                        "name": "color",
                        "hidden": false
                    },
                    {
                        "name": "longTextIndent",
                        "hidden": false
                    },
                    {
                        "name": "leftSpaceRemoved",
                        "hidden": false
                    },
                    {
                        "name": "lHeight",
                        "hidden": false
                    },
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": true
                    },
                    {
                        "name": "showInPage",
                        "hidden": true
                    },
                    {
                        "name": "unShowInPage",
                        "hidden": true
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    },
                    {
                        "name": "formatter",
                        "hidden": true
                    },
                    {
                        "name": "styler",
                        "hidden": true
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "title",
                "hidden": false
            },
            {
                "name": "field",
                "hidden": false
            },
            {
                "name": "testData",
                "hidden": false
            },
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "fontFamily",
                "hidden": false
            },
            {
                "name": "fontSize",
                "hidden": false
            },
            {
                "name": "fontWeight",
                "hidden": false
            },
            {
                "name": "letterSpacing",
                "hidden": false
            },
            {
                "name": "textAlign",
                "hidden": false
            },
            {
                "name": "lineHeight",
                "hidden": false
            },
            {
                "name": "color",
                "hidden": false
            },
            {
                "name": "hideTitle",
                "hidden": false
            },
            {
                "name": "longTextIndent",
                "hidden": false
            },
            {
                "name": "leftSpaceRemoved",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "unShowInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "lHeight",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            },
            {
                "name": "optionsGroup",
                "hidden": false
            },
            {
                "name": "borderLeft",
                "hidden": false
            },
            {
                "name": "borderTop",
                "hidden": false
            },
            {
                "name": "borderRight",
                "hidden": false
            },
            {
                "name": "borderBottom",
                "hidden": false
            },
            {
                "name": "borderWidth",
                "hidden": false
            },
            {
                "name": "borderColor",
                "hidden": false
            },
            {
                "name": "contentPaddingLeft",
                "hidden": false
            },
            {
                "name": "contentPaddingTop",
                "hidden": false
            },
            {
                "name": "contentPaddingRight",
                "hidden": false
            },
            {
                "name": "contentPaddingBottom",
                "hidden": false
            },
            {
                "name": "backgroundColor",
                "hidden": false
            },
            {
                "name": "formatter",
                "hidden": false
            },
            {
                "name": "styler",
                "hidden": false
            }
        ],
        "default": {
            "height": 42,
            "width": 550
        }
    },
    "table": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "field",
                        "hidden": false
                    },
                    {
                        "name": "testData",
                        "hidden": false
                    },
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "tableHeaderRepeat",
                        "hidden": false
                    },
                    {
                        "name": "tableFooterRepeat",
                        "hidden": false
                    },
                    {
                        "name": "autoCompletion",
                        "hidden": false
                    },
                    {
                        "name": "maxRows",
                        "hidden": false
                    },
                    {
                        "name": "columns",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "fontFamily",
                        "hidden": false
                    },
                    {
                        "name": "fontSize",
                        "hidden": false
                    },
                    {
                        "name": "lineHeight",
                        "hidden": false
                    },
                    {
                        "name": "textAlign",
                        "hidden": false
                    },
                    {
                        "name": "gridColumns",
                        "hidden": false
                    },
                    {
                        "name": "gridColumnsGutter",
                        "hidden": false
                    },
                    {
                        "name": "tableBorder",
                        "hidden": false
                    },
                    {
                        "name": "tableHeaderBorder",
                        "hidden": false
                    },
                    {
                        "name": "tableHeaderCellBorder",
                        "hidden": false
                    },
                    {
                        "name": "tableHeaderRowHeight",
                        "hidden": false
                    },
                    {
                        "name": "tableHeaderBackground",
                        "hidden": false
                    },
                    {
                        "name": "tableHeaderFontSize",
                        "hidden": false
                    },
                    {
                        "name": "tableHeaderFontWeight",
                        "hidden": false
                    },
                    {
                        "name": "tableBodyRowHeight",
                        "hidden": false
                    },
                    {
                        "name": "tableBodyRowBorder",
                        "hidden": false
                    },
                    {
                        "name": "tableBodyCellBorder",
                        "hidden": false
                    },
                    {
                        "name": "tableFooterBorder",
                        "hidden": false
                    },
                    {
                        "name": "tableFooterCellBorder",
                        "hidden": false
                    },
                    {
                        "name": "lHeight",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "列",
                "options": []
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "axis",
                        "hidden": false
                    },
                    {
                        "name": "styler",
                        "hidden": true
                    },
                    {
                        "name": "rowStyler",
                        "hidden": true
                    },
                    {
                        "name": "footerFormatter",
                        "hidden": true
                    },
                    {
                        "name": "rowsColumnsMerge",
                        "hidden": true
                    },
                    {
                        "name": "rowsColumnsMergeClean",
                        "hidden": true
                    },
                    {
                        "name": "groupFieldsFormatter",
                        "hidden": true
                    },
                    {
                        "name": "groupFormatter",
                        "hidden": true
                    },
                    {
                        "name": "groupFooterFormatter",
                        "hidden": true
                    },
                    {
                        "name": "gridColumnsFooterFormatter",
                        "hidden": true
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "field",
                "hidden": false
            },
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "fontFamily",
                "hidden": false
            },
            {
                "name": "fontSize",
                "hidden": false
            },
            {
                "name": "lineHeight",
                "hidden": false
            },
            {
                "name": "textAlign",
                "hidden": false
            },
            {
                "name": "gridColumns",
                "hidden": false
            },
            {
                "name": "gridColumnsGutter",
                "hidden": false
            },
            {
                "name": "tableHeaderRepeat",
                "hidden": false
            },
            {
                "name": "tableBorder",
                "hidden": false
            },
            {
                "name": "tableHeaderBorder",
                "hidden": false
            },
            {
                "name": "tableHeaderCellBorder",
                "hidden": false
            },
            {
                "name": "tableHeaderRowHeight",
                "hidden": false
            },
            {
                "name": "tableHeaderBackground",
                "hidden": false
            },
            {
                "name": "tableHeaderFontSize",
                "hidden": false
            },
            {
                "name": "tableHeaderFontWeight",
                "hidden": false
            },
            {
                "name": "tableBodyRowHeight",
                "hidden": false
            },
            {
                "name": "tableBodyRowBorder",
                "hidden": false
            },
            {
                "name": "tableBodyCellBorder",
                "hidden": false
            },
            {
                "name": "tableFooterBorder",
                "hidden": false
            },
            {
                "name": "tableFooterCellBorder",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "lHeight",
                "hidden": false
            },
            {
                "name": "autoCompletion",
                "hidden": false
            },
            {
                "name": "maxRows",
                "hidden": false
            },
            {
                "name": "columns",
                "hidden": false
            },
            {
                "name": "styler",
                "hidden": false
            },
            {
                "name": "rowStyler",
                "hidden": false
            },
            {
                "name": "tableFooterRepeat",
                "hidden": false
            },
            {
                "name": "footerFormatter",
                "hidden": false
            },
            {
                "name": "rowsColumnsMerge",
                "hidden": false
            },
            {
                "name": "groupFieldsFormatter",
                "hidden": false
            },
            {
                "name": "groupFormatter",
                "hidden": false
            },
            {
                "name": "groupFooterFormatter",
                "hidden": false
            },
            {
                "name": "gridColumnsFooterFormatter",
                "hidden": false
            }
        ],
        "default": {
            "width": 550
        }
    },
    "hline": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": true
                    },
                    {
                        "name": "fixed",
                        "hidden": true
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "borderWidth",
                        "hidden": true
                    },
                    {
                        "name": "borderStyle",
                        "hidden": false
                    },
                    {
                        "name": "borderColor",
                        "hidden": true
                    },
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": true
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "borderWidth",
                "hidden": false
            },
            {
                "name": "borderStyle",
                "hidden": false
            },
            {
                "name": "borderColor",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            }
        ],
        "default": {
            "borderWidth": 0.75,
            "height": 9,
            "width": 90
        }
    },
    "vline": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": true
                    },
                    {
                        "name": "fixed",
                        "hidden": true
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "borderWidth",
                        "hidden": true
                    },
                    {
                        "name": "borderStyle",
                        "hidden": false
                    },
                    {
                        "name": "borderColor",
                        "hidden": true
                    },
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": true
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "borderWidth",
                "hidden": false
            },
            {
                "name": "borderStyle",
                "hidden": false
            },
            {
                "name": "borderColor",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            }
        ],
        "default": {
            "height": 90,
            "width": 9
        }
    },
    "rect": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": true
                    },
                    {
                        "name": "fixed",
                        "hidden": true
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "borderWidth",
                        "hidden": true
                    },
                    {
                        "name": "borderStyle",
                        "hidden": true
                    },
                    {
                        "name": "borderColor",
                        "hidden": true
                    },
                    {
                        "name": "backgroundColor",
                        "hidden": true
                    },
                    {
                        "name": "transform",
                        "hidden": true
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": true
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "borderWidth",
                "hidden": false
            },
            {
                "name": "borderStyle",
                "hidden": false
            },
            {
                "name": "borderColor",
                "hidden": false
            },
            {
                "name": "backgroundColor",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            }
        ],
        "default": {
            "height": 90,
            "width": 90
        }
    },
    "oval": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": false
                    },
                    {
                        "name": "fixed",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "borderWidth",
                        "hidden": false
                    },
                    {
                        "name": "borderStyle",
                        "hidden": false
                    },
                    {
                        "name": "borderColor",
                        "hidden": false
                    },
                    {
                        "name": "backgroundColor",
                        "hidden": false
                    },
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": false
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "borderWidth",
                "hidden": false
            },
            {
                "name": "borderStyle",
                "hidden": false
            },
            {
                "name": "borderColor",
                "hidden": false
            },
            {
                "name": "backgroundColor",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            }
        ],
        "default": {
            "height": 90,
            "width": 90
        }
    },
    "html": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": false
                    },
                    {
                        "name": "unShowInPage",
                        "hidden": false
                    },
                    {
                        "name": "fixed",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": false
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    },
                    {
                        "name": "formatter",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "unShowInPage",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "formatter",
                "hidden": false
            }
        ],
        "default": {
            "height": 90,
            "width": 90
        }
    },
    "tableColumn": {
        "supportOptions": [
            {
                "name": "title",
                "hidden": false
            },
            {
                "name": "align",
                "hidden": false
            },
            {
                "name": "halign",
                "hidden": false
            },
            {
                "name": "vAlign",
                "hidden": false
            },
            {
                "name": "tableTextType",
                "hidden": false
            },
            {
                "name": "tableBarcodeMode",
                "hidden": false
            },
            {
                "name": "tableQRCodeLevel",
                "hidden": false
            },
            {
                "name": "tableColumnHeight",
                "hidden": false
            },
            {
                "name": "paddingLeft",
                "hidden": false
            },
            {
                "name": "paddingRight",
                "hidden": false
            },
            {
                "name": "tableSummaryTitle",
                "hidden": false
            },
            {
                "name": "tableSummaryText",
                "hidden": false
            },
            {
                "name": "tableSummaryColspan",
                "hidden": false
            },
            {
                "name": "tableSummary",
                "hidden": false
            },
            {
                "name": "tableSummaryAlign",
                "hidden": false
            },
            {
                "name": "tableSummaryNumFormat",
                "hidden": false
            },
            {
                "name": "tableSummaryFormatter",
                "hidden": true
            },
            {
                "name": "upperCase",
                "hidden": false
            },
            {
                "name": "renderFormatter",
                "hidden": true
            },
            {
                "name": "formatter2",
                "hidden": true
            },
            {
                "name": "styler2",
                "hidden": true
            },
            {
                "name": "stylerHeader",
                "hidden": true
            }
        ],
        "default": {
            "height": 90,
            "width": 90
        }
    },
    "barcode": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "title",
                        "hidden": false
                    },
                    {
                        "name": "field",
                        "hidden": false
                    },
                    {
                        "name": "testData",
                        "hidden": false
                    },
                    {
                        "name": "barcodeType",
                        "hidden": false
                    },
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "hideTitle",
                        "hidden": false
                    },
                    {
                        "name": "fixed",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "fontFamily",
                        "hidden": false
                    },
                    {
                        "name": "fontSize",
                        "hidden": false
                    },
                    {
                        "name": "fontWeight",
                        "hidden": false
                    },
                    {
                        "name": "letterSpacing",
                        "hidden": false
                    },
                    {
                        "name": "color",
                        "hidden": false
                    },
                    {
                        "name": "backgroundColor",
                        "hidden": false
                    },
                    {
                        "name": "textAlign",
                        "hidden": false
                    },
                    {
                        "name": "textContentVerticalAlign",
                        "hidden": false
                    },
                    {
                        "name": "lineHeight",
                        "hidden": false
                    },
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": false
                    },
                    {
                        "name": "unShowInPage",
                        "hidden": false
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    },
                    {
                        "name": "formatter",
                        "hidden": false
                    },
                    {
                        "name": "styler",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "title",
                "hidden": false
            },
            {
                "name": "field",
                "hidden": false
            },
            {
                "name": "testData",
                "hidden": false
            },
            {
                "name": "barcodeType",
                "hidden": false
            },
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "hideTitle",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "fontFamily",
                "hidden": false
            },
            {
                "name": "fontSize",
                "hidden": false
            },
            {
                "name": "fontWeight",
                "hidden": false
            },
            {
                "name": "letterSpacing",
                "hidden": false
            },
            {
                "name": "color",
                "hidden": false
            },
            {
                "name": "backgroundColor",
                "hidden": false
            },
            {
                "name": "textAlign",
                "hidden": false
            },
            {
                "name": "textContentVerticalAlign",
                "hidden": false
            },
            {
                "name": "lineHeight",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "unShowInPage",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "formatter",
                "hidden": false
            },
            {
                "name": "styler",
                "hidden": false
            }
        ],
        "default": {
            "width": 160,
            "height": 40,
            "title": "条形码",
            "barcodeType": "code128",
            "testData": "barcode"
        }
    },
    "qrcode": {
        "tabs": [
            {
                "name": "基础",
                "options": [
                    {
                        "name": "title",
                        "hidden": false
                    },
                    {
                        "name": "field",
                        "hidden": false
                    },
                    {
                        "name": "testData",
                        "hidden": false
                    },
                    {
                        "name": "qrcodeType",
                        "hidden": false
                    },
                    {
                        "name": "coordinate",
                        "hidden": false
                    },
                    {
                        "name": "widthHeight",
                        "hidden": false
                    },
                    {
                        "name": "hideTitle",
                        "hidden": false
                    },
                    {
                        "name": "fixed",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "样式",
                "options": [
                    {
                        "name": "fontFamily",
                        "hidden": false
                    },
                    {
                        "name": "fontSize",
                        "hidden": false
                    },
                    {
                        "name": "fontWeight",
                        "hidden": false
                    },
                    {
                        "name": "letterSpacing",
                        "hidden": false
                    },
                    {
                        "name": "color",
                        "hidden": false
                    },
                    {
                        "name": "backgroundColor",
                        "hidden": false
                    },
                    {
                        "name": "textAlign",
                        "hidden": false
                    },
                    {
                        "name": "textContentVerticalAlign",
                        "hidden": false
                    },
                    {
                        "name": "lineHeight",
                        "hidden": false
                    },
                    {
                        "name": "transform",
                        "hidden": false
                    },
                    {
                        "name": "zIndex",
                        "hidden": false
                    }
                ]
            },
            {
                "name": "高级",
                "options": [
                    {
                        "name": "pageBreak",
                        "hidden": false
                    },
                    {
                        "name": "showInPage",
                        "hidden": false
                    },
                    {
                        "name": "unShowInPage",
                        "hidden": false
                    },
                    {
                        "name": "axis",
                        "hidden": false
                    },
                    {
                        "name": "formatter",
                        "hidden": false
                    },
                    {
                        "name": "styler",
                        "hidden": false
                    }
                ]
            }
        ],
        "supportOptions": [
            {
                "name": "title",
                "hidden": false
            },
            {
                "name": "field",
                "hidden": false
            },
            {
                "name": "testData",
                "hidden": false
            },
            {
                "name": "qrcodeType",
                "hidden": false
            },
            {
                "name": "coordinate",
                "hidden": false
            },
            {
                "name": "widthHeight",
                "hidden": false
            },
            {
                "name": "hideTitle",
                "hidden": false
            },
            {
                "name": "fixed",
                "hidden": false
            },
            {
                "name": "fontFamily",
                "hidden": false
            },
            {
                "name": "fontSize",
                "hidden": false
            },
            {
                "name": "fontWeight",
                "hidden": false
            },
            {
                "name": "letterSpacing",
                "hidden": false
            },
            {
                "name": "color",
                "hidden": false
            },
            {
                "name": "backgroundColor",
                "hidden": false
            },
            {
                "name": "textAlign",
                "hidden": false
            },
            {
                "name": "textContentVerticalAlign",
                "hidden": false
            },
            {
                "name": "lineHeight",
                "hidden": false
            },
            {
                "name": "transform",
                "hidden": false
            },
            {
                "name": "zIndex",
                "hidden": false
            },
            {
                "name": "pageBreak",
                "hidden": false
            },
            {
                "name": "showInPage",
                "hidden": false
            },
            {
                "name": "unShowInPage",
                "hidden": false
            },
            {
                "name": "axis",
                "hidden": false
            },
            {
                "name": "formatter",
                "hidden": false
            },
            {
                "name": "styler",
                "hidden": false
            }
        ],
        "default": {
            "width": 80,
            "height": 80,
            "title": "二维码",
            "qrcodeType": "qrcode",
            "testData": "qrcode"
        }
    }
}